import { AidaEligibility } from '@ps/survey-utils';
import { BaseMapper } from '@ps/utils';

import { AidaEligibilityDto } from '../dtos/aida-eligibility.dto';

export class AidaEligibilityMapper extends BaseMapper<
  AidaEligibilityDto,
  AidaEligibility
> {
  public override fromDto(_from: AidaEligibilityDto): AidaEligibility {
    return {
      eligible: _from.eligible,
      errorMessages: _from.error_messages ?? [],
    };
  }
}
